export const inputLabelCss = {
  color: '#777e89',
  fontSize: '14px',
  marginBottom: 0.5,
  marginInline: '4px',
};

export const inputFieldCss = {
  height: '44px',
  borderColor: '#E5E7EB',
  borderRadius: '6px',
  '.MuiInputBase-input ': {
    padding: '10px 14px',
    '&.Mui-disabled': {
      cursor: 'not-allowed',
    },
  },
};

export const formHelperTextCss = {
  position: 'absolute',
  bottom: '-20px',
  marginInline: '8px',
  color: '#f44336',
};

export const datePickerCss = {
  width: '100%',
  input: {
    '&::placeholder': {
      color: '#747474',
    },
  },
  '.MuiInputBase-root': {
    height: '44px',
    borderRadius: '6px',
  },
};
